// TeamIdentityProvider — resolves a team crest URL with strict provenance.
// Priority: real provider crest -> cached real crest -> null (UI shows monogram).
// We NEVER scrape random web images or invent a crest. Until a licensed identity
// source (e.g. via the FootyStats enrichment adapter) supplies real crest URLs,
// this returns null and the UI falls back to a polished monogram.

export interface TeamIdentity {
  name: string;
  crestUrl: string | null; // real provider crest ONLY
}

const cache = new Map<string, string | null>();

// Register real crests obtained from a licensed provider (adapter fills this in).
export function registerTeamCrest(teamKey: string, crestUrl: string | null) {
  cache.set(teamKey.toLowerCase(), crestUrl || null);
}

export function teamIdentity(name: string | null | undefined): TeamIdentity {
  const clean = (name || "").trim();
  if (!clean) return { name: "", crestUrl: null };
  const cached = cache.get(clean.toLowerCase());
  return { name: clean, crestUrl: cached ?? null };
}

export function teamInitials(name: string | null | undefined): string {
  const clean = (name || "").trim();
  if (!clean) return "?";
  return clean.split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
}
